import { NOTA_DEBITO_EXTERNO_TYPES } from "../constants/nota-debito-externo.types";
import { ActionNDExt, NotaDebitoExterno, StateNDExt } from "../interfaces/nota-debito-externo.interface";

const initialState: NotaDebitoExterno = {
    formCliente: {
        granContribuyente: false,
        fecha: new Date().toLocaleDateString('en-CA'),
        tipoDocumento: '36',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',
    
        datosSucursal: [],
        datosDocumento: [],
        
        condicion: '',
        sucursal: '',
        serie:'',
        loadedSucursal: false,
    },

    errorsCliente: {
        granContribuyente: false,
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',

        datosSucursal: null,
        datosDocumento: null,
    
        condicion: '',
        sucursal: '',
        serie: '',
    },

    productosOriginales: [],
    productos: [],
    formProducto: {
        id: 0,
        original: false,
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        unidadMedida: '59'
    },

    errorsProducto: {
        id: 0,
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: '',
        descuento: '',
        servicio: false,
        exento: false
    },
    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,

    modal_documentoFisico: true,
    documentosFisico: {
      numId: "",
      tipo: "03",
      fecha: new Date().toLocaleDateString('en-CA'),
      monto: ""
    },

    clienteEncontrado: null,
    productoEdit: {
        id: 0,
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false
    },
    productoIndex: null,

    calculosGenerales: {
        operaciones: '',
        retencionRenta: '',
        iva: '',
        ivaPercibido: '',
        ivaRenetido: '',
    },

    calculosProducto: {
        neto: '',
        subtotal: '',
        descuento: '',
        total: '',
        iva: ''
    },

    view: 'Formularios',
    
    response_Emitir: null,
    response_QRcode: '',
    sucursales: [],
    documentos: [],
    totalOriginal: 0,
}

const notaDebitoExternoReducer = (
    state: NotaDebitoExterno = initialState,
    action: ActionNDExt
): StateNDExt => {
    switch (action.type) {
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_FORM_CLIENTE:
            return {...state, formCliente: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_FORM_PRODUCTO:
            return {...state, formProducto: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_HANDLE_ERRORS_CLIENTE:
            return {...state, errorsCliente: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_HANDLE_ERRORS_PRODUCTO:
            return {...state, errorsProducto: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_VIEW:
            return {...state, view: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_TOTAL_ORIGINAL:
            return {...state, totalOriginal: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_PRODUCTOS_ORIGINAL:
            return {...state, productosOriginales: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_PRODUCTOS:
            return {...state, productos: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_PRODUCTO_EDIT:
            return {...state, productoEdit: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_PRODUCTO_INDEX:
            return {...state, productoIndex: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_EDITAR_PRODUCTO:
            return {...state, modal_editar: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_ELIMINAR_PRODUCTO:
            return {...state, modal_eliminar: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_QUITAR_TODO:
            return {...state, modal_quitarTodo: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_EMITIR:
            return {...state, modal_emitir: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_EMITIDO:
            return {...state, modal_emitido: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_MAS_OPCIONES:
            return {...state, modal_masOpciones: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_ENVIAR_CORREO:
            return {...state, modal_enviarCorreo: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_ANULAR:
            return {...state, modal_anular: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_ANULADO:
            return {...state, modal_anulado: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_IMPRIMIR:
            return {...state, modal_imprimir: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_CALCULOS_GENERALES:
            return {...state, calculosGenerales: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_RESTART_FORM_PRODUCTO:
            return {...state, formProducto: initialState.formProducto}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_QR_CODE:
            return {...state, response_QRcode: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_RESPONSE_EMITIR:
            return {...state, response_Emitir: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_CALCULOS_PRODUCTO:
            return {...state, calculosProducto: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_CLIENTE_ENCONTRADO:
            return {...state, clienteEncontrado: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_CLIENTE_ENCONTRADO:
            return {...state, modal_clienteEncontrado: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_ACTIVE_MODAL_DOCUMENTO_FISICO:
            return {...state, modal_documentoFisico: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_SET_DOCUMENTO_FISICO:
            return {...state, documentosFisico: action.payload}
        case NOTA_DEBITO_EXTERNO_TYPES.NDEXT_RESTART_ALL:
            return initialState
        default:
            return state;
    }
}

export default notaDebitoExternoReducer;